import React from 'react';
import { Container, Grid, Segment } from 'semantic-ui-react';

import { base } from '../../helper/base-helper';
import AdmDBBrowser from './AdmDBBrowser';
import AdmFormChannel from '../forms/AdmFormChannel';
import AdmFormAction from '../forms/AdmFormAction';
import AdmFormRequirements from '../forms/AdmFormRequirements';
import AdmFormHowTo from '../forms/AdmFormHowTo';
import AdmFormReqType from '../forms/AdmFormReqType';
import AdmFormTags from '../forms/AdmFormTags';
import Publisher from '../forms/Publisher';

const timestamp = Date.now();

class AdminArea extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedDataObj: false,
      keyEditable: false,
      loading: true,
      actions: {},
      channels: {},
      howtos: {},
      reqtypes: {},
      requirements: {},
      tags: {},
    };

  }

// All database endpoints are synced to the state here
  componentWillMount() {
    this.actionsRef = base.syncState('actions',
    {
      context: this,
      state: 'actions',
      then: () => this.setState({loading: false})
    });
    this.channelsRef = base.syncState('channels',
    {
      context: this,
      state: 'channels',
      then: () => this.setState({loading: false})
    });
    this.howtosRef = base.syncState('howtos',
    {
      context: this,
      state: 'howtos',
      then: () => this.setState({loading: false})
    });
    this.reqtypesRef = base.syncState('reqtypes',
    {
      context: this,
      state: 'reqtypes',
      then: () => this.setState({loading: false})
    });
    this.requirementsRef = base.syncState('requirements',
    {
      context: this,
      state: 'requirements',
      then: () => this.setState({loading: false})
    });
    this.tagsRef = base.syncState('tags',
    {
      context: this,
      state: 'tags',
      then: () => this.setState({loading: false})
    });
  }

  componentWillReceiveProps(nextProps) {
    //this happens when a new admin area is chosen
    this.setState({
      selectedDataObj: null
    })
  }

  componentWillUnmount() {
    base.removeBinding(this.actionsRef);
    base.removeBinding(this.channelsRef);
    base.removeBinding(this.howtosRef);
    base.removeBinding(this.reqtypesRef);
    base.removeBinding(this.requirementsRef);
    base.removeBinding(this.tagsRef);
  }

  appointDataObj = (obj) => {
    this.setState({selectedDataObj: obj})
  };

  formLoader = (props) => {
    let compToLoad = null;
    switch (this.props.area) {
      case 'channels':
        compToLoad = <AdmFormChannel
          actions={this.state.actions}
          tagsSys={this.state.tags}
          defaultFormValue={{
            key: '',
            actionId: [],
            tagsSys: [],
            name: '',
            logo: 'question',
            color: '#FFF',
            url: '',
            published: false
          }}
          defaultFieldValidity={{
            _form: true,
            key: true,
            name: true,
            logo: true,
            color: true,
            url: true,
            _msgList: ['Please check all fields have values']
          }}
          {...props}/>;
        break;
      case 'actions':
        compToLoad = <AdmFormAction
          requirements={this.state.requirements}
          howtos={this.state.howtos}
          channels={this.state.channels}
          defaultFormValue={{
            key: '',
            chanId: '',
            howToIds: [],
            reqIds: [],
            name: '',
            descr: '',
            imgUrl: 'https://placehold.it/300x300?text=Screenshot',
            url: '',
            published: false }}
          defaultFieldValidity={{
            _form: true,
            key: true,
            chanId: true,
            howToIds: true,
            reqIds: true,
            name: true,
            descr: true,
            imgUrl: true,
            url: true,
            _msgList: ['Please check all fields have values']
          }}
          {...props} />;
        break;
      case 'requirements':
        compToLoad = <AdmFormRequirements
          actions={this.state.actions}
          channels={this.state.channels}
          reqtypes={this.state.reqtypes}
          defaultFormValue={{
            key: '',
            actionId: '',
            descr: '',
            fileFormats: [],
            maxMByte: 0,
            reytypeId: [],
            name: '',
            published: false }}
          defaultFieldValidity={{
            _form: true,
            key: true,
            actionId: true,
            descr: true,
            fileFormats: true,
            maxMByte: true,
            reytypeId: true,
            name: true,
            _msgList: ['Please check all fields have values']
          }}
          {...props} />;
        break;
      case 'howtos':
        compToLoad = <AdmFormHowTo
          actions={this.state.actions}
          channels={this.state.channels}
          defaultFormValue={{
            key: '',
            actionId: '',
            added: timestamp,
            headline: '',
            excerpt: '',
            link: '',
            score: 0 }}
          defaultFieldValidity={{
            _form: true,
            key: true,
            actionId: true,
            added: true,
            headline: true,
            excerpt: true,
            link: true,
            score: true,
            _msgList: ['Please check all fields have values']
          }}
          {...props} />;
        break;
      case 'reqtypes':
        compToLoad = <AdmFormReqType
          reqtypes={this.state.reqtypes}
          defaultFormValue={{
            key: '',
            name: '',
            icon: 'question'}}
          defaultFieldValidity={{
            _form: true,
            key: true,
            name: true,
            icon: true,
            _msgList: ['Please check all fields have values']
          }}
          {...props} />;
        break;
      case 'tags':
        compToLoad = <AdmFormTags
          tags={this.state.tags}
          defaultFormValue={{
            key: '',
            name: ''}}
          defaultFieldValidity={{
            _form: true,
            key: true,
            name: true,
            _msgList: ['Please check all fields have values']
          }}
          {...props} />;
        break;
      case 'publisher':
        compToLoad = <Publisher
          actions={this.state.actions}
          tagsSys={this.state.tags}
          requirements={this.state.requirements}
          howtos={this.state.howtos}
          channels={this.state.channels}
          reqtypes={this.state.reqtypes}
          tags={this.state.tags}
          {...props} />;
        break;
      default:
        return <h1>No Component found</h1>
    }
    return compToLoad;
  };

  setKeyEditable = (bool) => {
    if(typeof bool === 'boolean') {
      this.setState({selectedDataObj: false, keyEditable: bool})
    } else {
      console.error('setKeyEditable expected Boolen but instead received: '+ typeof bool);
    }
  };

  writeChangeLog = (obj, stateRef, operation) => {
    const timestamp = Date.now();
    let parentItem = '';
    let icon = '';
    let url = '';
    switch (stateRef) {
      case 'channels':
        parentItem = obj.key;
        icon = obj.logo;
        url = obj.url;
        break;
      case 'actions':
        parentItem = obj.chanId;
        icon = this.state.channels[obj.chanId].logo;
        url = `${this.state.channels[obj.chanId].url}/${obj.url}`;
        break;
      case 'requirements' || 'howtos':
        parentItem = obj.actionId;
        icon = this.state.channels[this.state.actions[obj.actionId].chanId].logo;
        url = `${this.state.channels[this.state.actions[obj.actionId].chanId].url}/${this.state.actions[obj.actionId].url}`;
        break;
      case 'tags' || 'reqtypes':
        parentItem = null;
        icon = 'tag';
        url = '';
        break;
      default:
        parentItem = null;
        icon = 'info';
        icon = 'tag';
        url = '';
      console.error('Unknown stateRef in writeChangeLog');
    }

    base.push(`_changelogs/`, {
      data: {
        event: `${operation} ${stateRef.slice(0, -1)}: "${obj.name}"`, //slicing to remove plural 's'
        key: obj.key,
        type: stateRef,
        timestamp,
        parentItem,
        icon,
        url
      },
      then(err) {
        if (err) {
          console.error(err);
        }
      }
    });
    return;
  };

  updateData = (obj, stateRef, e) => {
    e.preventDefault();
    this.writeChangeLog(obj, stateRef, 'Added / Updated');
    this.setState({
      [stateRef]: {
        ...this.state[stateRef],
        [obj.key]: obj
      },
      selectedDataObj: false,
      keyEditable: false
    });
  };

  deleteData = (obj, stateRef, e) => {
    e.preventDefault();
    this.writeChangeLog(obj, stateRef, 'Deleted');
    this.setState({
      [stateRef]: {
        ...this.state[stateRef],
        [obj.key]: null
      },
      selectedDataObj: false,
      keyEditable: false
    });
  };

  unpublishRelatives = (parentPath, key) => {
    const children = {...this.state[parentPath]}
    Object.keys(children).forEach(elem => {
      for(let prop in children[elem]) {
        if ({}.hasOwnProperty.call(children[elem], prop)) {

          if(children[elem][prop] === key) {
            children[elem]['published'] = false;
          }

          if(Array.isArray(children[elem][prop]) && children[elem][prop].includes(key)) {
            children[elem]['published'] = false;
          }
        }
      }
    });
    this.setState(children)
  };

  // This is not a good function - TODO: refactor using the new fanout update Object by firebase.
  fanoutData = (fanoutObj, operation, e) => {
    e.preventDefault();
    // parentPath = the root node, "channel"
    // child, "channelname"
    // endpoint , "actionid"
    const { parentPath, child, endpoint, data } = fanoutObj;
    const parentChildren = Object.keys(this.state[parentPath])
    let tmpStateObj = {};

    tmpStateObj[parentPath] = {...this.state[parentPath]};

    // ensure the function works as well without defining a child for delete only use (e.g. tests)
    if (child)
    tmpStateObj[parentPath][child][endpoint] = tmpStateObj[parentPath][child][endpoint] || [];

    // first delete the fanout data everywhere before writing the new one. That's why this is used in update and delete
    if (operation === 'delete' || operation === 'update') {

      parentChildren.filter((item) => typeof this.state[parentPath][item][endpoint] !== 'undefined').forEach(elem => {
        const elemDataArr = [...this.state[parentPath][elem][endpoint]] // e.g. Array of actions
        const dataIndex = elemDataArr.indexOf(data);

        if (dataIndex > -1) {
          tmpStateObj[parentPath][elem][endpoint] = elemDataArr.filter( (item, index) => index !== dataIndex);
          if(tmpStateObj[parentPath][elem][endpoint].length === 0 && operation === 'delete' && typeof child !== undefined){
            tmpStateObj[parentPath][child].published = false;
          }
        }
      });
    }

    // In case of update write the fanout data to the defined endpoint & child
    if (operation === 'update' && Array.isArray(tmpStateObj[parentPath][child][endpoint])) {
      tmpStateObj[parentPath][child][endpoint].push(data);
    };

    if (operation === 'update' && !Array.isArray(tmpStateObj[parentPath][child][endpoint])) {
      tmpStateObj[parentPath][child][endpoint] = data;
    };

    this.setState(tmpStateObj);
  };

  checkIsUnique = (endpoint, property, value) => {
    let testArr = [];
    if(!this.state.loading)
    testArr = Object.keys(this.state[endpoint]).map(el => this.state[endpoint][el][property]);
    return !testArr.includes(value);
  };

  render() {
    const spaceForDbbBrowser = (this.props.area !== 'publisher') ? 10 : 16;

    return (
      <Container>
        <Grid stackable>
          {
            (this.props.area !== 'publisher')
            ?
              <Grid.Column width={6}>
                <Container>
                  <AdmDBBrowser
                    loading={this.state.loading}
                    setKeyEditable={this.setKeyEditable}
                    selectObj={this.appointDataObj}
                    //TODO: Check this might be errorprone? It requires areaName === endpoint.
                    endpointData={this.state[this.props.area]} />
                </Container>
              </Grid.Column>
            : ''
          }
          <Grid.Column width={spaceForDbbBrowser}>
            <Segment>
              <Container>
                {
                  (!this.state.loading && Object.keys(this.state.actions).length)
                  ? <this.formLoader
                      area={this.props.area}
                      selectedDataObj={this.state.selectedDataObj}
                      keyEditable={this.state.keyEditable}
                      checkIsUnique={this.checkIsUnique}
                      setKeyEditable={this.setKeyEditable}
                      updateData={this.updateData}
                      deleteData={this.deleteData}
                      fanoutData={this.fanoutData}
                      unpublishRelatives={this.unpublishRelatives}
                    />
                  : <Segment basic loading />
                }

              </Container>
            </Segment>
          </Grid.Column>
        </Grid>
      </Container>
    );
  }

}

export default AdminArea;



// WEBPACK FOOTER //
// ./src/components/protected/AdmArea.js